import type { LawnStripeRunIdInput } from './types'

function fnv1a(value: string) {
  let hash = 0x811c9dc5
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 0x01000193)
  }
  return hash >>> 0
}

/**
 * Produces a compact analytics correlation ID without hidden randomness.
 * The caller supplies entropy (for example crypto.randomUUID()) so tests can
 * reproduce an ID and production runs can remain collision-resistant.
 */
export function createLawnStripeRunId({
  startedAtMs,
  entropy,
}: LawnStripeRunIdInput): string {
  if (!Number.isFinite(startedAtMs) || startedAtMs < 0) {
    throw new Error('startedAtMs must be a non-negative finite number.')
  }
  const normalizedTime = Math.floor(startedAtMs)
  const source = `${normalizedTime}:${String(entropy)}`
  const suffix = fnv1a(source).toString(36).padStart(7, '0')
  return `lss_${normalizedTime.toString(36)}_${suffix}`
}
